import axiosInstance from "../../config"; // Your Axios config

export const updateLosssOrProfitService = async (data, token) => {
    try {

            // const response = await axiosInstance.post('/ui/add-daily-max-loss_profit', data);
        const response = await axiosInstance.post(
            '/ui/add-daily-max-loss_profit',
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }
        );





        return {
            status:response.status,
            success: true, //return success 
            message: response.data?.message || "update successfully",  //return  message
            data: response.data,      //return data response
        };
    } catch (error) {


        return {
            success: false,
            message: error.response?.data?.message || "Failed to send reset link",
            status: error.response?.status || 500,
            errors: error.response?.data?.errors || null,
        };
    }
};
